<template>
  <el-form ref="form" :model="formData" size="small" :rules="rules">
    <el-row>
      <el-form-item
        :label="$l('form_label_fileType') || '文件类型'"
        prop="fileType"
      >
        <dict-select
          size="small"
          clearable
          filterable
          v-model="formData.fileType"
          :body="fileTypeParams"
          url="/sys/common/dict/system"
        ></dict-select>
      </el-form-item>
      <el-form-item :label="$l('form_label_remark') || '备注说明'">
        <el-input
          v-model="formData.remark"
          :placeholder="$l('INDEX.tips_input_placeholder') || '请输入...'"
          type="textarea"
          :maxlength="250"
          show-word-limit
        >
        </el-input>
      </el-form-item>
    </el-row>
    <el-row>
      <el-upload
        action="#"
        drag
        :file-list="listFile"
        :auto-upload="false"
        :on-change="onFileChange"
      >
        <i class="el-icon-upload"></i>
        <div class="el-upload__text">
          {{ $l('INDEX.file_upload_tips_first') || '将文件拖到此处，或' }}
          <em>{{ $l('INDEX.file_upload_tips_last') || '点击上传' }}</em>
        </div>
        <div slot="file" slot-scope="{ file }">
          <a
            style="text-decoration: none;margin-right:50px"
            class="el-upload-list__item-name"
          >
            <i class="el-icon-document"></i>
            {{ file.name }}
          </a>
          <i class="el-icon-close" @click="listFile = []"></i>
        </div>
      </el-upload>
    </el-row>
  </el-form>
</template>

<script>
import EditLoading from '@/mixins/edit-loading'
import validate from '@/libs/util.validate'
export default {
  mixins: [EditLoading],
  props: { customerFileCode: { type: String, default: '' } },
  data() {
    return {
      fileTypeParams: { dictType: 'customerFileType' },
      formData: {},
      listFile: [],
      rules: {
        fileType: [
          {
            required: true,
            message: this.$l('INDEX.tips_select_placeholder') || '请选择',
            trigger: 'change',
          },
        ],
      },
    }
  },
  mounted() {
    this.getData()
  },
  methods: {
    getData() {
      if (!this.customerFileCode) return
      this.$api
        .shipmentCustomerFileDetailApi({
          customerFileCode: this.customerFileCode,
        })
        .then((res) => {
          const { fileName, fileUrl, fileCode, fileType, remark } = res.body
          this.formData = { fileType, remark }
          this.listFile = [{ name: fileName, url: fileUrl, fileCode }]
        })
    },
    onFileChange(file) {
      this.listFile = [file]
    },
    async save() {
      const result = await validate.formValidate([this.$refs.form])
      if (!result) return false

      if (!this.listFile || !this.listFile.length) {
        this.$message({
          message: this.$l('INDEX.tips_choose_statement_doc') || '请选择文件',
          type: 'warning',
        })
        return false
      }

      const uploadFile = this.listFile[0]
      const { status, name } = uploadFile
      const { fileType } = this.formData
      if (fileType.indexOf('-seal') >= 0) {
        const legalImg = [
          'JPEG',
          'TIFF',
          'PNG',
          'GIF',
          'PSD',
          'RAW',
          'EPS',
          'SVG',
        ]

        const fileSuffix = name
          .substring(name.lastIndexOf('.') + 1)
          .toLocaleUpperCase()

        if (!legalImg.includes(fileSuffix)) {
          this.$message.error(`该文件类型下仅支持上传图片(${legalImg.join()})`)
          return
        }
      }

      this.loadingOpen()
      const listFile =
        status == 'ready' ? await this.uploadFiles() : this.listFile
      if (!listFile || !listFile.length) {
        this.$message({
          message: '文件上传失败',
          type: 'warning',
        })
        this.loadingClose()
        return false
      }
      if (listFile.length !== listFile.filter(Boolean).length) {
        this.$message({
          message: '文件上传失败',
          type: 'warning',
        })
        this.loadingClose()
        return false
      }

      const { fileCode, url: fileUrl, name: fileName } = listFile[0]
      const params = {
        fileCode,
        fileUrl,
        fileName,
        ...this.formData,
        customerFileCode: this.customerFileCode,
      }
      const res = await this.$api
        .shipmentCustomerFileUpdateApi(params)
        .catch(() => null)
      this.loadingClose()
      const { status: resStatus } = res || {}
      if (resStatus != 200) {
        this.$message.error(this.$l('INDEX.tips_save_no') || '保存失败！')
        return
      }
      this.$message({
        showClose: true,
        message: this.$l('INDEX.tips_save_ok') || '保存成功！',
        type: 'success',
      })
      this.$emit('reload')
      this.$emit('close')
    },
    uploadFiles() {
      if (!this.listFile || !this.listFile.length) return Promise.resolve([])
      const uploadTask = this.listFile.map((file) => {
        return this.$api
          .SYS_UPLOAD(file.raw)
          .then((res) => ({
            fileCode: res.body.fileId,
            url: res.body.url,
            name: file.name,
          }))
          .catch(() => null)
      })
      return Promise.all(uploadTask)
    },
  },
}
</script>
<style lang="scss" scoped>
// 重写element 样式
::v-deep {
  .el-upload-dragger {
    width: 478px;
  }
}
</style>
